<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Cash/Salary/Expense") }}</h3>
    </v-btn>
    <v-btn
      color="blue"
      style="float: right"
      x-small
      class="tariff-right-headers"
      target="_blank"
      :href="'/expense/create?accountCode=DriverExpense'"
    >
      + {{ $i18n.t("Add") }}
    </v-btn>
    <v-row style="padding: 10px 20px">
      <expenses :expenseType="'Expenses'" :entity_id="driver._id" />
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Expenses from "@/views/driver/Expenses.vue";
import common from "@/store/common/module/common";

@Component({
  name: "CashSalary",
  props: {
    value: {
      default: null,
    },
  },
  components: {
    Expenses,
  },
})
export default class CashSalary extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>